import "./App.css"; // Import the CSS file for styling
import React, { useState, useEffect } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom"; // added

const API_ROOT = "https://www.legalexpertsindia.in";


const Dashboard = () => {
 // const navigate = useNavigate();

  const [title, setTitle] = useState("");
  const [content, setContent] = useState("");
  const [image, setImage] = useState(null);
  const [isAdmin, setIsAdmin] = useState(false);

  const [blogs, setBlogs] = useState([]);
  const [loading, setLoading] = useState(false);


  

  useEffect(() => {
    fetchBlogs();
    setIsAdmin(!!localStorage.getItem("adminToken"));
  }, []);

  const fetchBlogs = async () => {
    try {
      const res = await axios.get(`${API_ROOT}/api/blogs`);
      setBlogs(res.data || []);
    } catch (err) {
      console.error("Fetch blogs error:", err);
    }
  };



   

  const handleSubmit = async (e) => {
    e.preventDefault();
    const token = localStorage.getItem("adminToken");
    if (!token) {
      alert("Please login first");
      return;
    }

    if (!title.trim() || !content.trim()) {
      alert("Title and content are required");
      return;
    }

    const formData = new FormData();
    formData.append("title", title);
    formData.append("content", content);
    if (image) formData.append("image", image);

    try {
      setLoading(true);
      await axios.post(`${API_ROOT}/api/blogs`, formData, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "multipart/form-data",
        },
      });
      setTitle("");
      setContent("");
      setImage(null);

 


      // fallback if you are not using react-router:
      // window.location.href = "/blog";

      await fetchBlogs();
      alert("Blog posted");
      // navigate to Blog page
      // navigate("/blog"); // react-router navigation
    } catch (err) {
      console.error("Post blog error:", err);
      alert("Error posting blog");
    } finally {
      setLoading(false);
    }
  };

  const handleLogout = () => {
    localStorage.removeItem("adminToken");
    alert("You have been logged out.");
    setIsAdmin(false);

    
  };

const deleteBlog = async (id) => {
  const token = localStorage.getItem("adminToken");
  if (!token) {
    alert("Please login first");
    return;
  }

  try {
    await axios.delete(`${API_ROOT}/api/blogs/${id}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    alert("Blog deleted successfully");
    fetchBlogs(); // Refresh the blog list after deletion
  } catch (err) {
    console.error("Delete blog error:", err.response?.data || err.message);
    alert("Error deleting blog: " + (err.response?.data?.error || err.message));
  }
};

  return (
  
    <div className="container">
      <img src="/admin.jpg" alt="Header" />  

      
        <div style={{ maxWidth: 700, margin: "0 auto 2rem" }}>
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 12 }}>
           

           <marquee direction="right"> <h3> Welcome Admin ! </h3> </marquee>


           
                 
            
          </div>

          <form onSubmit={handleSubmit} style={{ display: "flex", flexDirection: "column", gap: 8 }} className="internship-form">
            <center><h3>Post a New Blog</h3></center>
            <input placeholder="Title" value={title} onChange={(e) => setTitle(e.target.value)} required />
            <textarea placeholder="Content" value={content} onChange={(e) => setContent(e.target.value)} rows={6} required />
            <input type="file" accept="image/*" onChange={(e) => setImage(e.target.files[0] || null)} />
            <button type="submit" disabled={loading}>{loading ? "Posting..." : "Submit"}</button>
          </form>

         <button onClick={handleLogout}>Logout</button>
        </div>
    

      <hr style={{ maxWidth: 900, margin: "1rem auto" }} />

    

      <div style={{ maxWidth: 900, margin: "1rem auto" }}>
        <h3>All Posts</h3>
        {isAdmin ? (
          blogs.length === 0 ? (
            <p>No posts yet.</p>
          ) : (
            <div className="grid">
              {blogs.map((b) => (
                <div key={b.id || b._id || b.title} style={{ display: "flex", gap: 12, padding: 12, borderRadius: 8, boxShadow: "0 1px 3px rgba(0,0,0,0.1)", alignItems: 'center' }}>
                  <div>
                    <h4 style={{ margin: "0 0 6px" }}>{b.title}</h4>
                    {b.image && (
                      <img
                        src={b.image.startsWith('http') ? b.image : `https://www.legalexpertsindia.in/api${b.image}`}
                        alt={b.title}
                        style={{ maxWidth: '100%', height: 'auto', marginBottom: 8 }}
                      />
                    )}
                    <p style={{ margin: 0 }}>{b.content?.length > 100000 ? `${b.content.slice(0, 100000)}...` : b.content}</p>
                    {b.createdAt && (
  <small style={{ color: "#090808" }}>
    {new Date(b.createdAt).toLocaleDateString("en-GB")}
  </small>
)}
                  </div>
                  <button onClick={() => deleteBlog(b.id)} style={{ marginLeft: 'auto' }}>Delete</button>
                </div>
              ))}
            </div>
          )
        ) : null}
      </div>
          </div>
        
  
  );
};

export default Dashboard;
